import React from 'react';
import './reference-details.scss';
import { SVGS } from '../../../assets';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import { SpinnerLoader } from '../../spinner';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputAdornment from '@mui/material/InputAdornment';
import { useReferenceDetails } from './use-reference-details';

const commonSx = {
  '& .MuiSelect-select': {
    display: 'flex',
    alignItems: 'center',
    padding: '14px 0',
  },
  '.MuiOutlinedInput-notchedOutline': {
    borderRadius: '8px',
    border: '1.25px solid #8C8C8C',
  },
  '&:hover .MuiOutlinedInput-notchedOutline': {
    borderColor: 'none',
  },
  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
    border: '1.25px solid #8C8C8C',
  },
};

interface ReferenceDetailsProps {
  formData: Record<string, string | string[]>;
  onChange: (key: string, value: string | string[]) => void;
}

export const ReferenceDetails: React.FC<ReferenceDetailsProps> = ({
  formData,
  onChange,
}) => {
  const { reference_Details, isLoading } = useReferenceDetails();

  return (
    <div className="reference-details">
      {reference_Details.map((field) => (
        <div key={field.key} className="reference-details--field">
          {field.label && (
            <label className="reference-details--label font-medium">
              {field.label}
            </label>
          )}

          <FormControl size="small" hiddenLabel>
            <Select
              multiple={field.multiple}
              displayEmpty
              size="small"
              variant="outlined"
              value={(formData[field.key] as string[]) ?? []}
              onOpen={() => {}}
              sx={commonSx}
              onChange={(e) => {
                if (field.multiple) {
                  const value = e.target.value as string[];
                  onChange(field.key, value);
                } else {
                  const value = e.target.value as string;
                  onChange(field.key, [value]);
                }
              }}
              input={
                <OutlinedInput
                  startAdornment={
                    <InputAdornment position="start">
                      <img src={field.icon} />
                    </InputAdornment>
                  }
                />
              }
              inputProps={{ 'aria-label': 'Without label' }}
              renderValue={(selected) => {
                const selectedValues = selected as string[];
                if (!selectedValues.length) {
                  return (
                    <span className="reference-message-text font-medium">
                      {field.placeholder}
                    </span>
                  );
                }

                const selectedItems = field.data.filter((item) =>
                  selectedValues.includes(item.id.toString())
                );
                return selectedItems.map((item) => item.name).join(', ');
              }}
            >
              {isLoading ? (
                <MenuItem disabled value="">
                  <SpinnerLoader color={'#000000'} size={20} />
                </MenuItem>
              ) : field.data.length === 0 ? (
                <MenuItem disabled value="">
                  <span className="reference-message-text font-medium">
                    {field.emptyMessage}
                  </span>
                </MenuItem>
              ) : (
                field.data.map((item) => (
                  <MenuItem key={item.id} value={item.id}>
                    <div>
                      <div className="reference-options-view">
                        {(formData[field.key] as string[])?.includes(
                          item.id.toString()
                        ) ? (
                          <img src={SVGS.CheckboxBlack} />
                        ) : (
                          <img src={SVGS.UncheckedBox} />
                        )}
                        <span className="reference-options-view--text font-regular">
                          {item.name}
                        </span>
                      </div>
                      <div className="reference-options-view--subtext-text font-regular">
                        <span>Date: {item.date}</span>
                        <span>Order Value: {item.value}</span>
                      </div>
                    </div>
                  </MenuItem>
                ))
              )}
            </Select>
          </FormControl>
        </div>
      ))}
    </div>
  );
};
